/**
 * True en `npm start` (NODE_ENV=development). En local no redirigimos al login
 * externo aunque `REACT_APP_LOGIN_URL` esté definida.
 */
function isLocalDevelopment(): boolean {
  return process.env.NODE_ENV === 'development'
}

/**
 * Redirige al login de Rankmi solo si la URL está definida y no estamos en desarrollo local.
 * Si `REACT_APP_LOGIN_URL` falta, el navegador interpretaría la cadena "undefined"
 * como ruta relativa (p. ej. http://localhost:3001/undefined).
 */
export function redirectToExternalLogin(): void {
  if (isLocalDevelopment()) {
    console.debug(
      '[LMS] Desarrollo local: no se redirige al login externo (aunque exista REACT_APP_LOGIN_URL).'
    )
    return
  }
  const url = process.env.REACT_APP_LOGIN_URL
  if (!url) {
    console.warn(
      '[LMS] REACT_APP_LOGIN_URL no está definida; omitiendo redirección al login.'
    )
    return
  }
  window.location.href = url
}
